import "./fonts.css2.js";
const t = "https://static.parastorage.com/services/fonts-data/dist/fonts.dk2d6odll3hja1g2js4p.css";
export {
  t as default
};
//# sourceMappingURL=fonts.css.js.map
